<template>
    <div class="purchase-item">
        <div class="purchase-wrapper">
            <div class="purchase-img" @click="clickdetail()">
                <div class="purchase-img-wrapper">
                    <img class="img-fluid" :src="purchase.fullImageUrl" />
                </div>
            </div>
            <div class="purchase-info" @click="clickPurchase()">
                <div class="purchase-name ellipsis-2">{{purchase.name}}</div>
                <div class="purchase-row">
                    <div class="purchase-redeemdate" v-if="type != 'surveyapprove'">{{lbl.purchase.redeem_on}}</div>
                </div>
                <div class="purchase-row">
                    <div class="purchase-redeemdate" v-if="type != 'surveyapprove'">{{getRedeemedDate()}}</div>
                </div>

                <div class="purchase-row"
                    v-if="type === 'purchase' && purchase.delivered === false">
                    <div class="purchase-icon serial" :class="{'expireed':!isActive}"></div>
                    <div class="purchase-txt serial" :class="{'expireed':!isActive}"
                        v-html="purchaseMessage"></div>
                </div>
                <div class="purchase-row"
                    v-if="type === 'draw'">
                    <div class="purchase-txt no-icon"
                        v-html="purchaseMessage"></div>
                </div>
                <div class="purchase-row"
                    v-if="type === 'interface'">
                    <div class="purchase-txt no-icon"
                        v-html="purchaseMessage"></div>
                </div>
                <div class="purchase-row"
                    v-if="type === 'surveyapprove'">
                    <div class="purchase-txt no-icon"
                        :class="surveyStatus"
                        v-html="surveyMessage"></div>
                </div>
                <div class="purchase-row delivery"
                    v-if="isShowDelivery">
                    <div class="purchase-txt no-icon">
                        {{ lblPurchase.status }} : 
                        <span :class="purchase.isShipped == false && purchase.parcelNo == null ? 'prepare-product'
                            : purchase.isShipped == false && purchase.parcelNo != null ? 'delivery'
                            : purchase.isShipped == true && purchase.parcelNo != null ? 'shipped' : ''">
                            {{ deliveryMessage }}
                        </span>
                    </div>
                    <div class="purchase-txt no-icon" v-if="purchase.parcelNo">
                        {{ lblPurchase.parcel_no }} : 
                        <span class="parcel-no">{{purchase.parcelNo}}</span>
                        <span class="copy" v-clipboard:copy="purchase.parcelNo">
                            <img src="../../assets/icon/icon-copy.svg"/>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import moment from "moment";
import Account from '@/helper/AccountHelper.js';
import Util from '@/helper/Utility.js';
import Moment from 'moment';
import Locale from '@/helper/locale/locale.js';

export default {
    name: 'PurchaseItem',
    components: '',
    props: {
        lbl: Object,
        index: Number,
        purchase: Object,
        categoryName: String,
    },
    data: function () {
        return {
            campaignType: Vue.CampaignType,
            deliveryMessage: '',
            isActive: false,
            isShipped: false,
            isShowAdsMessage: false,
            isShowDelivery: false,
            isShowPrivilegeMessage: true,
            isWinner: false,
            lblHistory: this.lbl.history,
            lblPurchase: this.lbl.purchase,
            privilegeMessage: this.purchase.privilegeMessage,
            purchaseMessage: '',
            surveyStatus: '',
            surveyMessage: '',
            type: 'purchase', //draw, interface, purchase.
        };
    },
    created: function () {
        this.initialPurchase();
        this.setupPrivilegeMessage();
    },
    mounted: function () {
    },
    methods: {
        //event
        clickPurchase: function () {
            var gtm = {
                        "event_label": this.purchase.name,
                        "privilege_category_name": this.categoryName,
                        "privilege_id": this.purchase.id,
                        "timestamp": moment().format("YYYYMMDD HH:mm:ss")
                    };
            Vue.ga.event(this, "privilege_history", "use_privilege", gtm.event_label, null, gtm);
            this.$emit('clickPurchase', this.index);
        },
        clickdetail: function () {
            var label = this.purchase.id +"|"+ this.purchase.name;
            var gtm = {
                        "event_label": this.purchase.name,
                        "privilege_category_name": this.categoryName,
                        "privilege_id": this.purchase.id,
                        "timestamp": moment().format("YYYYMMDD HH:mm:ss")
                    };
            Vue.ga.event(this, "privilege_history", "click_privilege_history_card", label, null, gtm);

            if (this.purchase.type == Vue.CampaignType.Interface) {
                this.openInterface();
            } else {
                this.$router.push({ name: 'detail_history', params: { campaignId: this.purchase.id,form: "history" }})
            }
            // var path = "/campaign/" + this.purchase.id + "/?form=history";
            // this.$router.push(path);
        },
        openInterface: function() {
            if (this.purchase.privilegeFormat == 'link') {
                var sToken = Account.getShuffleToken();
                var url = this.purchase.privilegeMessage;

                url = url.replace('<campaign_id>', this.purchase.CampaignId);
                url = url.replace('<token>', sToken);
                url = url.replace('<serial>', this.purchase.serial);
                url = url.replace('<locale>', Locale.getLocaleCode());

                url += '&return_url=' + encodeURIComponent(window.location.href);

                window.location.replace(url);
            }
        },
        //method
        initialPurchase: function () {
            if (this.purchase.privilegeMessageFormat
                && this.purchase.privilegeMessageFormat.toLowerCase() === 'html')
                this.isShowPrivilegeMessage = false;

            //purchase message.
            switch(this.purchase.type) {
                case this.campaignType.Draw:
                    this.isDraw = true;
                    this.type = 'draw';
                    this.purchaseMessage = this.lblPurchase.not_draw1 + (this.lblPurchase.not_draw2 ? ' ' + this.lblPurchase.not_draw2 : '');

                    if (this.purchase.hasWinner) {
                        this.isActive = true;
                        if (this.purchase.isWinner) {
                            this.isWinner = true;
                            this.purchaseMessage = this.lblPurchase.draw_winner1 + (this.lblPurchase.draw_winner2 ? ' ' + this.lblPurchase.draw_winner2 : '');

                            if (this.isShowAdsMessage && this.purchase.adsMessage)
                                this.purchaseMessage += "<br />" + this.purchase.adsMessage;
                        } else {
                            this.isWinner = false;
                            this.purchaseMessage = this.lblPurchase.draw_not_win1 + (this.lblPurchase.draw_not_win2 ? ' ' + this.lblPurchase.draw_not_win2 : '');
                        }
                    }

                    this.isShowPrivilegeMessage = false;
                    break;
                case this.campaignType.Buy:
                case this.campaignType.Free:
                case this.campaignType.Deal:
                    if (this.purchase.serial == "XXXXXXX") {
                        this.purchaseMessage = this.lblPurchase.code_expired;
                    } else {
                        this.isActive = true;
                        this.purchaseMessage = this.lblPurchase.show_code;
                    }
                    break;
                case this.campaignType.Interface:
                    this.type = 'interface';
                    if (this.purchase.expireIn &&
                        this.purchase.expireIn < 0) {
                        this.purchaseMessage = this.lblPurchase.code_expired;

                        this.isShowPrivilegeMessage = false;
                    } else {
                        if (this.purchase.pointType == "get")
                            this.purchaseMessage = this.lblPurchase.interface_get;
                        else
                            this.purchaseMessage = this.lblPurchase.interface_use;
                    }
                    if(this.purchase.interfaceDisplay === 'survey') {
                        this.type = 'survey';
                    } else if (this.purchase.interfaceDisplay === 'surveyapprove') {
                        this.type = 'surveyapprove';
                        if (this.purchase.approveSurvey == 1) {
                            this.surveyStatus = 'approve';
                            this.surveyMessage = this.lblPurchase.approve_survey;
                        } else if (this.purchase.approveSurvey == -1) {
                            this.surveyStatus = 'reject';
                            this.surveyMessage = this.lblPurchase.reject_survey;
                        } else {
                            this.surveyStatus = 'wait';
                            this.surveyMessage = this.lblPurchase.wait_survey;
                        }
                    }
                    break;
            }
            //delivery.
            if (this.purchase.delivered === true) {
                this.isShowDelivery = true;
                if (this.purchase.type === this.campaignType.Draw) {
                    if (!this.purchase.hasWinner) {
                        this.isShowDelivery = false;
                    } else {
                        if (!this.purchase.isWinner)
                            this.isShowDelivery = false;
                    }
                }

                if (this.purchase.isShipped == false && this.purchase.parcelNo == null) {
                    this.isShipped = false;
                    this.deliveryMessage = this.lblPurchase.prepare_product;
                } else if (this.purchase.isShipped == false && this.purchase.parcelNo != null) {
                    this.isShipped = false;
                    this.deliveryMessage = this.lblPurchase.delivery;
                } else if (this.purchase.isShipped == true && this.purchase.parcelNo != null) {
                    this.isShipped = true;
                    this.deliveryMessage = this.lblPurchase.shipped;
                }
            }

            this.deliveryMessage = Util.newLineToBr(this.deliveryMessage);
            this.privilegeMessage = Util.newLineToBr(this.privilegeMessage);
            this.purchaseMessage = Util.newLineToBr(this.purchaseMessage);
        },
        setupPrivilegeMessage: function() {
            if (this.purchase.privilegeFormat == 'link') {
                this.isShowPrivilegeMessage = false;
            }
        },
        //utility
        getPointMessage: function () {
            var pointType = this.purchase.pointType == 'get' ? this.lblHistory.get_point : this.lblHistory.use_point;
            var pointUnit = this.lblHistory.point + (this.purchase.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            return pointType + " " + this.purchase.pointPerUnit + " " + pointUnit;
        },
        getRedeemedDate: function () {
            var timestamp = this.purchase.redeemDate;
            var redeemedDate = Moment.unix(timestamp).utc();

            var year = Moment.unix(timestamp).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) {
                var thaiyear = redeemedDate.get('year') + 543;
                //for 2 digits.
                year = thaiyear.toString().substring(2, 4);
            }

            var monthString = this.lbl.date.month_short[redeemedDate.format('M') - 1];
            var strDate = '';
            strDate = redeemedDate.format('DD') + " " + monthString + " " + year;
            strDate += ' - ' + redeemedDate.format('HH:mm');

            return strDate;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";


.purchase-item {
    @extend %display-flex;
    width: 50%;
    flex: 0 0 50%;
    margin-bottom: 20px;

    &:nth-child(2n - 1) {
        padding-right: 10px;
    }

    &:nth-child(2n) {
        padding-left: 10px;
    }

    @media (max-width: $max-width-mobile) {
        width: 100%;
        flex: 0 0 100%;

        &:nth-child(2n - 1) {
            padding-right: 0;
        }

        &:nth-child(2n) {
            padding-left: 0;
        }
    }

    .purchase-wrapper {
        @extend %display-flex;
        width: 100%;
        padding: 10px 15px;
        background-color: white;
        border-radius: 5px;

        .purchase-img {
            width: 50%;
            flex: 0 0 50%;

            .purchase-img-wrapper {
                position: relative;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                }

                &:before {
                    position: relative;
                    content: "";
                    display: block;
                    padding-top: 66.66%;
                }
            }
        }

        .purchase-info {
            width: 50%;
            flex: 0 0 50%;
            padding-left: 10px;
            .purchase-name {
                font-size: 20px;
                font-weight: 500;
                line-height: 1.05;
                margin-bottom: 8px;
            }


            .purchase-row {
                display: flex;
                .purchase-icon {
                    &.serial {
                        width: 15px;
                        height: 15px;
                        margin-right: 5px;
                        background-image: url('../../assets/history/icon-history.png');

                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        background-position: center center;

                        &.expireed {
                            background-image: url('../../assets/history/icon-rewards-history-02@3x.png');
                        }
                    }
                }
                .purchase-txt {
                    font-size: 17px;
                    font-weight: 500;
                    line-height: 1;

                    &.serial {
                        color: $primery-color;
                        border-bottom: 1px solid $primery-color;
                        font-weight: bold;

                        &.expireed {
                            color: #e1251b;
                            border: 0;
                        }
                    }

                    &.approve {
                        font-size: 18px;
                        padding-top: 35px;
                        color: #2e7d21;
                    }

                    &.reject {
                        font-size: 18px;
                        padding-top: 35px;
                        color: #c30000;
                    }

                    &.wait {
                        font-size: 18px;
                        padding-top: 35px;
                        color: #ff7a00;
                    }
                }

                &.delivery {
                    display: block;
                    color: #4b4b4b;
                    .shipped {
                        color: #0eac00;
                    }
                    .delivery {
                        color: #ff7a00;
                    }
                    .prepare-product {
                        color: #0e78c1;
                    }
                    .parcel-no {
                        color: #0e78c1;
                    }
                    .copy {
                        padding-left: 4px;
                        img{
                            width: 12px;
                            height: auto;
                        }
                    }
                }

                .purchase-redeemdate {
                    font-size: 17px;
                    font-weight: 500;
                    color: #808085;
                    line-height: 0.94;
                }
            }
        }
    }
}
</style>
